// iOS mutes Web Audio when the ring/silent switch is on. Asking for the "playback" audio session
// (Safari 17+) and playing a silent <audio> element (older iOS) moves the page to media playback,
// so the layers are heard either way. Must be called from a tap.
let unlocked = null;

const silentWav = () => {
  const rate = 8000, n = rate; // one second of silence
  const buf = new ArrayBuffer(44 + n);
  const v = new DataView(buf);
  const w = (o, s) => [...s].forEach((c, i) => v.setUint8(o + i, c.charCodeAt(0)));
  w(0, "RIFF"); v.setUint32(4, 36 + n, true); w(8, "WAVE"); w(12, "fmt ");
  v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
  v.setUint32(24, rate, true); v.setUint32(28, rate, true); v.setUint16(32, 1, true); v.setUint16(34, 8, true);
  w(36, "data"); v.setUint32(40, n, true);
  for (let i = 0; i < n; i += 1) v.setUint8(44 + i, 128);
  return URL.createObjectURL(new Blob([buf], { type: "audio/wav" }));
};

export const unlockPlayback = () => {
  try { if (navigator.audioSession) navigator.audioSession.type = "playback"; } catch { /* unsupported */ }
  if (!unlocked) {
    unlocked = new Audio(silentWav());
    unlocked.loop = true;
    unlocked.setAttribute("playsinline", "");
  }
  unlocked.play().catch(() => {});
};

export const releasePlayback = () => { unlocked?.pause(); };
